<template>
    <div>
        <v-navigation-drawer class="d-print-none" v-model="$store.state.drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <!-- {{search_links}} -->
            <v-list dense>
                <v-combobox dense required :items="search_links" item-text="name" v-model="goto_link" label="Search links" outlined return-object clearable @change="gotoLink" />
                <v-divider></v-divider>
                <template>
                    <div v-for="item in items" :key="item.name">
                        <v-list-group v-if="item.children" :key="item.name" v-model="item.model" :prepend-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" append-icon>
                            <template v-slot:activator>
                                <v-list-item class="card icon">
                                    <v-list-item-content class="icon">
                                        <v-list-item-title class="icon">{{ item.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <div v-for="(child, i) in item.children" :key="i">
                                <router-link class="sidebar-link" :to="{ name: child.link, params: { role_type:child.para_role_type,role_name:child.para_role }}">
                                    <v-list-item class="sidebar-link-item card icon">
                                        <!--<v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-action>-->
                                        <v-list-item-content class="icon">
                                            <v-list-item-title style="margin-left: 70px;" class="icon">{{ child.name }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </router-link>
                            </div>
                        </v-list-group>
                        <v-divider></v-divider>
                    </div>
                </template>
                <template v-if="module_link">
                    <router-link class="sidebar-link" :to="{name:'modules'}">
                        <v-list-item class="sidebar-link-item card icon">
                            <v-list-item-title class="icon" style="text-align: center; color: green;">Module Management</v-list-item-title>
                        </v-list-item>
                    </router-link>
                </template>
                <template v-if="easycheck_url && erp_easycheck_flag == 'YES'">
                    <form :action="easycheck_url" name="easycheck" method="POST" v-if="flag">
                        <input name="uid" type="hidden" id="udf2" :value="uid" />
                        <input name="hash_key" type="hidden" id="udf2" :value="hash_key" />
                        <input name="erp_url" type="hidden" id="udf2" :value="erp_url" />
                        <input name="device_name" type="hidden" id="device_name" :value="device_name" />
                        <center>
                            <v-btn rounded type="submit" text color="green" small><strong>Proceed To EasyCheck</strong></v-btn>
                        </center>
                    </form>
                </template>
            </v-list>
        </v-navigation-drawer>
        <!-- <epsFooter :drawer="$store.state.drawer"></epsFooter> -->
    </div>
</template>
<script>
    import axios from "axios";
    import epsFooter from "../shared/Footer";
    export default {
        data() {
            return {
                items: [],
                module_link: false,
                search_links: [],
                goto_link: null,

                //added by vrushali
                easycheck_url: "http://localhost:8080", //live url
                uid: "",
                hash_key: "",
                flag: false,
                erp_url: "",
                device_name:"",
                erp_easycheck_flag:null
            };
        },
        components: {
            epsFooter: epsFooter,
        },
        methods: {
            checkBrowser() {          
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var browserName = navigator.appName;
            var fullVersion = '' + parseFloat(navigator.appVersion);
            var majorVersion = parseInt(navigator.appVersion, 10);
            var nameOffset, verOffset, ix;
            var Name = "Unknown OS";
            var os = "";
            if ((verOffset = nAgt.indexOf("Edg")) != -1) {
                browserName = "Edge";
                fullVersion = nAgt.substring(verOffset + 4);
            } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
                browserName = "Chrome";
                fullVersion = nAgt.substring(verOffset + 7);
            } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
                browserName = "Firefox";
                fullVersion = nAgt.substring(verOffset + 8);
            } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
                browserName = "Safari";
                fullVersion = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf("Version")) != -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = nAgt.substring(verOffset + 5);
            }

            // In most other browsers, "name/version" is at the end of userAgent 
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
                (verOffset = nAgt.lastIndexOf('/'))) {
                browserName = nAgt.substring(nameOffset, verOffset);
                fullVersion = nAgt.substring(verOffset + 1);
                if (browserName.toLowerCase() == browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) != -1)
                fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) != -1)
                fullVersion = fullVersion.substring(0, ix);
            if (nAgt.toLowerCase().indexOf("windows") >= 0) {
                Name = "Windows";
            } else if (nAgt.toLowerCase().indexOf("mac") >= 0) {
                Name = "Mac";
            } else if (nAgt.toLowerCase().indexOf("x11") >= 0) {
                Name = "Unix";
            } else if (nAgt.toLowerCase().indexOf("android") >= 0) {
                Name = "Android";
            } else if (nAgt.toLowerCase().indexOf("iphone") >= 0) {
                Name = "IPhone";
            } else {
                Name = "UnKnown, More-Info: " + nAgt;
            }
            //alert("os::"+Name)

            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }
             this.device_name=browserName + "_" + Name + "_" + fullVersion
             //alert('device_name'+this.device_name);
        },
            gotoLink() {
                if (this.goto_link != null) {
                    if (this.search_links.includes(this.goto_link)) {
                        //alert(this.goto_link.link)
                        //this.$router.push({name:this.goto_link.link});
                        let routeData = this.$router.resolve({ name: this.goto_link.link });
                        //this.goto_link=null;
                        window.open(routeData.href, "_blank");
                    }
                }
            },
        },
        mounted() {
            this.checkBrowser();
            this.flag = false;
            axios
                .get("/home/dashboardsidebar")
                .then((res) => {
                    this.items = res.data.links;
                    this.module_link = res.data.to_show_module_management;
                    this.search_links = res.data.search_links;
                    this.erp_easycheck_flag = res.data.erp_easycheck_flag;
                    //added by vrushali
                    if(res.data.erp_easycheck_flag == "YES"){
                    this.uid = res.data.uid;
                    this.easycheck_url = res.data.url;
                    this.erp_url = res.data.erp_url;
                    this.hash_key = res.data.key;
                    this.flag = true;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.$router.push("/");
                });
        },
    };
</script>
<style scoped>
    .sidebar-link {
        text-decoration: none;
    }
    .sidebar-link-item:hover {
        background-color: rgb(202, 206, 209) !important;
    }
    .icon {
        color: #0f2027; /* fallback for old browsers */
        color: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        color: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .icon:hover {
        color: white;
    }
    .card {
    }
    .card:hover {
        font-weight: bold !important;
        background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base)); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white !important;
        box-shadow: 20px 20px 20px grey !important;
        -webkit-transition: box-shadow 0.3s ease-in !important;
    }
</style>
